// extracted by mini-css-extract-plugin
export default {"tableTitle":"styles_tableTitle__P62td","countText":"styles_countText__QHVjM","collapseIcon":"styles_collapseIcon__y3RJn","iconRotate":"styles_iconRotate__nfDjA"};